import { cn } from "@/lib/utils";
import React, { FC, SVGProps } from "react";

const Scintilla: FC<SVGProps<SVGSVGElement>> = ({ className, ...props }) => {
  return (
    <svg
      className={cn("fill-white", className)}
      width="194"
      height="195"
      viewBox="0 0 194 195"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_15028_97393)">
        <path d="M92.5051 46.7882C93.6471 42.1473 100.245 42.1473 101.387 46.7882L109.778 80.8848C110.182 82.5277 111.46 83.8131 113.101 84.2267L146.999 92.7721C151.607 93.9336 151.607 100.48 146.999 101.642L113.101 110.187C111.46 110.601 110.182 111.886 109.778 113.529L101.387 147.626C100.245 152.266 93.6471 152.266 92.5051 147.626L84.1143 113.529C83.71 111.886 82.4318 110.601 80.7913 110.187L46.8928 101.642C42.2855 100.48 42.2855 93.9336 46.8928 92.7721L80.7913 84.2267C82.4318 83.8131 83.71 82.5277 84.1143 80.8848L92.5051 46.7882Z" />
      </g>
      <defs>
        <filter
          id="filter0_d_15028_97393"
          x="0.335457"
          y="0.205574"
          width="193.22"
          height="194.002"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="21.551" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15028_97393"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15028_97393"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Scintilla;
